import { z } from 'zod';
import { AddressWithPhoneNumberSchema } from '../Address/schemas';
import { OrderLineSchema } from '../Order/schemas';
import { ShippingMethodSchema } from '../ShippingMethod/schemas';
import { PromotionSchema } from '../Cart/Promotion/schemas';
import { ShippingProvider } from './ShippingProvider';
import OrderStatus from '../Order/OrderStatus';
import PromotionTarget from '../Cart/Promotion/PromotionTarget';
import type { ITrackingEvent } from './ITrackingEvent';
import type { IMaskedShipment } from './IMaskedShipment';
import type { IShipment } from './IShipment';
import type IShipmentPromotion from '../Cart/Promotion/Shipment/IShipmentPromotion';
import type { IBasicShipment } from './IBasicShipment';

/** Zod schema for {@link ITrackingEvent}. */
export const TrackingEventSchema = z.object({
  id: z.number(),
  event: z.string()
}) satisfies z.ZodType<ITrackingEvent>;

/** Zod schema for {@link IShipmentPromotion}. */
export const ShipmentPromotionSchema = PromotionSchema.extend({
  target: z.literal(PromotionTarget.Shipment)
}) satisfies z.ZodType<IShipmentPromotion>;

/** Zod schema for {@link IBasicShipment}. */
export const BasicShipmentSchema = z.object({
  id: z.string(),
  trackingNumber: z.string().nullable(),
  items: z.array(z.object({})),
  status: z.nativeEnum(OrderStatus)
}) satisfies z.ZodType<IBasicShipment>;

/** Zod schema for {@link IMaskedShipment}. */
export const MaskedShipmentSchema = BasicShipmentSchema.extend({
  shippingProvider: z.nativeEnum(ShippingProvider).nullable(),
  shippingMethod: ShippingMethodSchema,
  trackingUrl: z.string(),
  items: z.array(OrderLineSchema),
  promotions: z.array(ShipmentPromotionSchema)
}) satisfies z.ZodType<IMaskedShipment>;

/** Zod schema for {@link IShipment}. */
export const ShipmentSchema = MaskedShipmentSchema.extend({
  shippingAddress: AddressWithPhoneNumberSchema.optional(),
  trackingEvents: z.array(TrackingEventSchema)
}) satisfies z.ZodType<IShipment>;
